module.exports = __webpack_public_path__ + "static/media/ки.55dc8254.mp3";